import React from 'react';
import Modal from 'react-modal';
import _ from 'lodash';
import '../css/SystemIntegratorAdd.css';
import ErrorText from '../ErrorText';
import Loader from './Loader';
import SnackBar from './SnackBar';
import { Input, TextField, MenuItem, FormControl, InputLabel, Typography, Select, Switch } from '@mui/material';


// Distributor page to add new Distributor page

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        backgroundColor: '#EFF3F6',
        // background: 'none !important'
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};


const customStylesSuccess = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};



export default class UserAddNew extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
            noOfParams: [],
            errorMessage: [],
            modalIsOpenSuccess: false,
            showErrorMessage: false,
            rolesData: [],
            usersList: [],
            userListReversData: [],
            loader: false,
            snackbarActive: false,
            snackbarMessage: '',
            selectedUser: [],
            email: "",
            roles: "",
            fullName: "",
            group: '',
            reportTo: '',

        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalSuccess = this.closeModalSuccess.bind(this);

    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    closeModalSuccess() {
        this.setState({
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp',
            modalIsOpen: false
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpenSuccess: false
                }, () => this.props.closeAllModal())
            }, 500);
        })
    }

    afterOpenModal() {

    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp',

        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => this.props.closeAllModal())
            }, 500);
        })
    }

    componentDidMount() {
        this.getallrealdata();
    }

    getallrealdata = () => {
        this.setState({ loader: true });

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        };

        // Fetch roles
        const fetchRoles = fetch('/cloud/addRoles/', {
            method: "GET",
            headers: headers
        }).then(res => res.json());

        // Fetch users
        const fetchUsers = fetch('/cloud/addUsers/', {
            method: "GET",
            headers: headers
        }).then(res => res.json());

        // Wait for both to complete
        Promise.all([fetchRoles, fetchUsers])
            .then(([rolesData, userData]) => {
                // console.log(roleData);
                console.log(userData);
                this.setState({
                    rolesData,
                    actualdata: rolesData,
                    usersList: userData, // 👈 New state for storing fetched users
                    userListReversData: userData,
                    loader: false
                }, () => {
                    // this.renderTableData();
                });

                // console.log(this.state.usersList);
            })
            .catch(error => {
                // console.error("❌ Error fetching data:", error);
                this.setState({ loader: false });
            });
    }

    AddingUsers = (type) => {
        const { fullName, email, group, reportTo } = this.state;

        if (!fullName.trim() || !email.trim() || !group) {
            this.setState({ error: "Please fill all required fields" });
            return;
        }

        const jsonData = {
            name: fullName,
            role: group,
            user_email: email,
            role_assigned: reportTo
        };

        this.setState({ loader: true });

        const url = this.state.user_id
            ? `/cloud/addUsers_detail/${this.state.user_id}`
            : "/cloud/addUsers/";

        fetch(url, {
            method: this.state.user_id ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": localStorage.getItem("csrftoken"),
            },
            body: JSON.stringify(jsonData),
        })
            .then(async (response) => {
                if (response.status === 403) {
                    window.location = "/login/session-timeout";
                    return;
                }

                const data = await response.json();

                if (!response.ok) {
                    // Display the error message from backend
                    const errorMessage = data.message || "Something went wrong!";
                    this.setState({ loader: false, error: errorMessage });
                    alert(errorMessage); // or use a Snackbar / toast if available
                    return;
                }

                // Success
                if (type === "add") {
                    this.setState({
                        fullName: "",
                        email: "",
                        group: "",
                        reportTo: "",
                        error: "",
                        successmsgmodaldata: 'dataadded',
                        loader: false
                    });
                    alert("User added successfully!");
                    this.closeModal(); // Close modal after success
                }
            })
            .catch((error) => {
                // console.error("❌ Error adding user:", error);
                this.setState({ loader: false, error: "Network or server error." });
                alert("Network or server error.");
            });
    }



    AddUsers = () => {
        const { fullName, email } = this.state;

        this.setState({ showErrorMessage: true });

        // Basic validation
        if (!fullName.trim()) {
            alert("Please enter the User Name");
            return;
        }

        if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            alert("Please enter a valid Email");
            return;
        }

        // If no error, proceed
        this.setState({ loader: true }, () => this.AddingUsers('add'));
    }

    render() {
        return (
            <React.Fragment>
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                {this.state.loader ? <Loader /> : null}
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas fa-timess fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>Add User</h3>
                    <div className="row">
                        {this.state.addAnotherSuccess ? <div class="col-12 my-2 alert alert-success fade show" role="alert">
                            Successfully registered the User.
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            </button>
                        </div> : null}
                    </div>
                    <div className="row">
                        <div className="col-6 mx-0 px-0" >
                            <TextField
                                required
                                sx={{ marginTop: '4.5%' }}
                                value={this.state.fullName}
                                onChange={(e) => {
                                    const input = e.target.value;
                                    const filtered = input.replace(/[^a-zA-Z ]/g, ''); // allow only letters and spaces
                                    this.setState({ fullName: filtered });
                                }}
                                label="Name of the User"
                                name="fullName"
                                inputProps={{ maxLength: 30 }}
                                fullWidth
                                variant="standard"
                                size="small"
                            />

                        </div>
                        <div className="col-6   text-field-modal" style={{ paddingLeft: '9px', paddingRight: '5px', marginTop: '16px' }} >
                            <TextField
                                required
                                select
                                variant="standard"
                                fullWidth
                                label="Group"
                                value={this.state.group}
                                onChange={(e) => this.setState({ group: e.target.value })}
                                error={this.state.group === '' && this.state.showErrorMessage}
                                helperText={
                                    this.state.group === '' && this.state.showErrorMessage
                                        ? 'Please select the Group'
                                        : ''
                                }
                            >
                                <MenuItem value="" disabled>Select Group</MenuItem>
                                {this.state.rolesData.map((option, index) => (
                                    <MenuItem key={index} value={option.role_id}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextField>

                        </div>

                        <div className="col-6 mx-0 px-0 ">
                            <TextField
                                required
                                sx={{ marginTop: '4.5%' }}
                                value={this.state.email}
                                onChange={(e) => this.setState({ email: e.target.value })}
                                // error={ErrorText('email', this.state.email) !== 'No Error' && this.state.showErrorMessage}
                                // helperText={ErrorText('email', this.state.email) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Email' : ''}
                                label="Email"
                                name="email"
                                inputProps={{ maxLength: 255 }}
                                fullWidth
                                variant="standard"
                                size="small"
                            />
                        </div>

                        <div className="col-6   text-field-modal" style={{ paddingLeft: '9px', paddingRight: '5px', marginTop: '16px' }} >

                            {this.state.usersList.length > 0 && (
                                <FormControl fullWidth variant="standard" style={{ marginBottom: "10px" }}>
                                    {/* <InputLabel>Report To</InputLabel> */}
                                    <InputLabel>
                                        Report To&nbsp;
                                        <span style={{ fontWeight: 'normal', fontSize: '0.9rem', color: '#999' }}>
                                            (Optional)
                                        </span>
                                    </InputLabel>

                                    <Select
                                        value={this.state.reportTo}
                                        onChange={(e) => {
                                            this.setState({ reportTo: e.target.value, userError: false });
                                        }}
                                    >
                                        {this.state.usersList
                                            .filter(user => user.user_email !== this.state.email)
                                            .map((user) => (
                                                <MenuItem key={user.id} value={user.user_email}>
                                                    {user.name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                    {this.state.userError && <Typography color="error">Please select a user</Typography>}
                                </FormControl>
                            )}

                        </div>

                    </div>
                    <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey" style={{ marginRight: '15px' }} onClick={this.closeModal}>Cancel</div>
                        <i className="fa fa-star-christmas fa-spin"></i>
                        <div className="btn btn-new-green " onClick={this.AddUsers.bind(this, 'add')}>Add</div>

                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.modalIsOpenSuccess}
                    style={customStylesSuccess}
                    className={this.state.modalStateAftereOpenSuccess}
                    contentLabel="Example Modal">
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                            <i className="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <div className="display-4 text-center">
                        <h3 className="modal-heading thanks-message">User Added Successfully</h3>
                        <i class="fas fa-check-circle update"></i>
                        <br />
                        <div className="btn btn-new-grey"
                            onClick={this.closeModalSuccess}>
                            Close
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
